const currencyStyle = (lang, symbol, total) => {
  if (lang === 'fr') return total + symbol;
  else return symbol + total;
};

module.exports = {
  currencyStyle,
};
